<form class="mt-8 max-w-2xl">
  <div class="flex flex-col md:flex-row gap-6 mb-8">
    <sbnb-radio-card [selected]="owner.type === 'individual'" (click)="owner.type = 'individual'">
      <h3 class="mb-2">Individual</h3>
      <p>Owner statements | invoices are addressed to an individual.</p>
    </sbnb-radio-card>

    <sbnb-radio-card [selected]="owner.type === 'company'" (click)="owner.type = 'company'">
      <h3 class="mb-2">Company</h3>
      <p>Owner statements | invoices are addressed to a company.</p>
    </sbnb-radio-card>
  </div>

  <div class="flex gap-4">
    <div *ngIf="owner.type === 'individual'" class="w-full">
      <label class="block text-sm text-gray-600" for="firstName">First name</label>
      <mat-form-field class="w-full">
        <input matInput name="firstName" placeholder="First name" [(ngModel)]="owner.firstName" required />
        <mat-error>First name is required for Individuals</mat-error>
      </mat-form-field>
    </div>

    <div class="w-full">
      <label class="block text-sm text-gray-600" for="name">
        {{ owner.type === 'individual' ? 'Last name' : 'Name' }}
      </label>
      <mat-form-field class="w-full">
        <input matInput name="name" placeholder="Name" [(ngModel)]="owner.name" required />
        <mat-error>Name is required</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="w-full">
    <label class="block text-sm text-gray-600" for="email">Email</label>
    <mat-form-field class="w-full">
      <input matInput type="email" name="email" placeholder="Email" email [(ngModel)]="owner.email" required />
      <mat-error>Please enter a valid email address</mat-error>
    </mat-form-field>
  </div>

  <div class="w-full">
    <label class="block text-sm text-gray-600" for="phone">Phone (optional)</label>
    <mat-form-field class="w-full">
      <ngx-mat-intl-tel-input
        name="phone"
        [preferredCountries]="['us']"
        [(ngModel)]="owner.phone"></ngx-mat-intl-tel-input>
    </mat-form-field>
  </div>

  <ng-container *ngIf="!addressExpanded">
    <div class="w-full">
      <label class="block text-sm text-gray-600" for="address">Mailing address</label>
      <sbnb-address-autocomplete
        class="mb-4 block"
        [existingAddressLabel]="
          owner.address.line1
            ? owner.address.line1 +
              ', ' +
              owner.address.city +
              ', ' +
              owner.address.state +
              ', ' +
              owner.address.postalCode
            : ''
        "
        (setAddress)="setAddress($event)"></sbnb-address-autocomplete>

      <sbnb-button type="secondary" size="mini" label="Enter manually" (clicked)="addressExpanded = true"></sbnb-button>
    </div>
  </ng-container>

  <ng-container *ngIf="addressExpanded">
    <h4 class="mb-4">Mailing address</h4>
    <div class="grid grid-cols-2 gap-4">
      <div class="w-full">
        <label class="block text-sm text-gray-600" for="line1">Line 1</label>
        <mat-form-field class="w-full">
          <input matInput type="text" name="line1" autocomplete="address-line1" [(ngModel)]="owner.address.line1" />
        </mat-form-field>
      </div>

      <div class="w-full">
        <label class="block text-sm text-gray-600" for="line2">Line 2</label>
        <mat-form-field class="w-full">
          <input matInput type="text" name="line2" autocomplete="address-line2" [(ngModel)]="owner.address.line2" />
        </mat-form-field>
      </div>

      <div class="w-full">
        <label class="block text-sm text-gray-600" for="city">City</label>
        <mat-form-field class="w-full">
          <input matInput type="text" name="city" autocomplete="address-city" [(ngModel)]="owner.address.city" />
        </mat-form-field>
      </div>

      <div class="w-full">
        <label class="block text-sm text-gray-600" for="state">State</label>
        <mat-form-field class="w-full">
          <input matInput type="text" name="state" [(ngModel)]="owner.address.state" />
        </mat-form-field>
      </div>

      <div class="w-full">
        <label class="block text-sm text-gray-600" for="zip">ZIP Code</label>
        <mat-form-field class="w-full">
          <input matInput type="text" name="zip" autocomplete="postal-code" [(ngModel)]="owner.address.postalCode" />
        </mat-form-field>
      </div>

      <div class="w-full" *ngIf="countries && countries.length > 0">
        <label class="block text-sm text-gray-600" for="country">Country</label>
        <mat-form-field class="w-full">
          <mat-select [(ngModel)]="owner.address.country" name="country">
            <mat-option>
              <ngx-mat-select-search
                ngModel
                (ngModelChange)="filterCountries($event)"
                name="country-search"
                placeholderLabel="Search..."></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let country of filteredCountries$ | async" [value]="country.alpha2code">
              {{ country.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <sbnb-button
      type="secondary"
      size="mini"
      label="Return to address search"
      (clicked)="addressExpanded = false"></sbnb-button>
  </ng-container>

  <!-- properties-->
  <ng-container *ngIf="mode !== 'edit' && properties && properties.length > 0">
    <h3 class="mt-8">Properties</h3>
    <p class="mb-4">
      Select one or multiple properties that belong to this Owner. This determines which properties will appear on the
      Owner's Statement | Invoice.
    </p>

    <sbnb-statements-property-picker
      [properties]="properties"
      [selectedProperties]="this.owner.properties"
      [disabledProperties]="propertiesBelongingToAnotherOwner"
      (selectedPropertiesChange)="owner.properties = $event"></sbnb-statements-property-picker>
  </ng-container>
</form>
